import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { WorkflowRun } from '@qtek/shared/models';
import { Observable } from 'rxjs';

export interface WorkflowRunWsMessage extends BaseWebsocketMessage {
  // A run list for the runs query reply, a single run otherwise.
  res?: WorkflowRun | WorkflowRun[];
  sts?: { sts?: string; message?: string };
}

@Injectable({ providedIn: 'root' })
export class WorkflowRunService {
  private readonly manager = new WSEntityManager(
    inject(WebSocketService),
    'WorkflowRun'
  );

  subscribeRuns(
    workflowId: string,
    mysid: string
  ): Observable<WorkflowRunWsMessage> {
    return this.manager.subscribeEntity({
      mysid,
      cmd: 'query',
      view: 'runs',
      prms: { workflow: workflowId },
    });
  }

  subscribeHistory(
    runId: string,
    mysid: string
  ): Observable<WorkflowRunWsMessage> {
    return this.manager.subscribeEntity({
      mysid,
      cmd: 'get',
      id: runId,
      view: 'history',
      prms: { id: runId },
    });
  }
}
